import React from "react";

function Header() {
  return (
    <div className="whole">
      <div className="row">
        <div className="first_four_images col-3 d-flex justify-content-evenly mt-1">
          <a href="">
            <img
              id="LFE"
              src="images\04-Life final logo.png"
              alt="LFE"
              width="105"
              height="55"
              style={{ marginTop: "10px", marginLeft: "4px" }}
            />
          </a>
          <a href="">
            <img
              id="G20"
              src="images\G20_India_2023_logo.png"
              alt="G20"
              width="95"
              height="65"
              style={{ marginTop: "5px", marginLeft: "8px" }}
            />
          </a>
          <a href="">
            <img
              id="EIACP"
              src="images\EIACP_Logo.png"
              alt="EIACP"
              width="63"
              style={{ marginTop: "5px", marginLeft: "8px" }}
            />
          </a>
          <a href="">
            <img
              id="ENVIS"
              src="images\ENVIS Logo_FINAL.png"
              alt="ENVIS"
              width="63"
              style={{ marginTop: "1px", marginLeft: "8px" }}
            />
          </a>
        </div>
        <div className="heading col-6" style={{ marginLeft: "0px" }}>
          <h2
            style={{
              textAlign: "center",
              fontFamily: "sans-serif",
              color: "#0C0950",
            }}
          >
            Sahyadri Issue 91(XCI)
          </h2>
          <h3
            style={{
              textAlign: "center",
              fontFamily: "sans-serif",
              color: "#0C0950",
            }}
          >
            <b>Spatial Distribution of Plants in Kerala</b>
          </h3>
        </div>

        <div
          style={{
            filter: "brightness(100%)",
            mixBlendMode: "multiply",
            marginTop: "7px",
            marginRight: "0px",
          }}
          className="col-3 second_four_images  d-flex justify-content-evenly mt-1"
        >
          <a href="">
            <img
              id="IISc"
              src="images\IISc_Master_Seal.jpg"
              alt="IISc"
              width="78"
            />
          </a>
          <a href="">
            <img src="images\EWRG_logo.jpeg" alt="EWRG" width="70" />
          </a>
          <a href="">
            <img
              id="NE"
              src="images\National Emblem (1).png"
              alt=""
              width="60"
              style={{ marginTop: "3px" }}
            />
          </a>
          <a href="">
            <img
              src="images/Aazadi_ka_amrit_mahotsav_logo.png"
              alt="AKAM"
              width="75"
              height="65"
              style={{ marginTop: "5px" }}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Header;
